// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-picker-next-button[data-v-91b40828],.date-picker-previous-button[data-v-91b40828]{padding:0;flex:0 0 50px}.date-picker-calendar-view--wide[data-v-91b40828],.date-picker-container--wide[data-v-91b40828]{width:784px}.date-picker-header-title--left[data-v-91b40828]{padding-right:62px}.date-picker-header-title--right[data-v-91b40828]{padding-left:62px}", ""]);
// Exports
module.exports = exports;
